module.exports = __webpack_public_path__ + "img/Gull.e00e0e3b.webp";